﻿export default function SkeletonWrapper({
  width = 'w-full',
  height = 'h-full',
  isLoading = false,
  className = '',
  children,
}) {
  if (isLoading) {
    return (
      <div
        className={`animate-pulse bg-gray-200 rounded relative overflow-hidden ${width} ${height} ${className} 
          before:absolute before:inset-0 before:-translate-x-full
          before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent
          before:animate-[shimmer_2s_infinite]`}
      />
    );
  }

  return <>{children}</>;
}
